module.exports = __webpack_public_path__ + "static/media/mars.17a7c93f.jpg";